import {
  ASSIST_MAX_INPUT,
  ASSIST_MIN_INPUT,
} from "@/shared/writing-assistant/writing-assistant.schema";

// Normalize the textarea content into a sendable `input`, or null when the
// notes are too short to draft from. Truncation (not rejection) past the cap:
// rough notes only need the head, and the box allows up to 5000 chars.
export function prepareDraftNotes(raw: string): string | null {
  const notes = raw.trim();
  if (notes.length < ASSIST_MIN_INPUT) return null;
  return notes.slice(0, ASSIST_MAX_INPUT);
}
